import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AngularFireDatabase } from 'angularfire2/database';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, OnDestroy {
  subPress: Subscription;
  subNotices: Subscription;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    autoplay: true,
    margin: 24,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    navSpeed: 700,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: { items: 1 },
      400: { items: 2 },
      740: { items: 3 },
      940: { items: 4 }
    },
    nav: true
  };

  customOptions1: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    autoplay: true,
    margin: 24,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    navSpeed: 700,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: { items: 1 },
      740: { items: 2 },
    },
    nav: true
  };

  events: any[] = [
    {
      imgUrl: 'https://placehold.co/600x400/EEE/31343C',
      date: '10 Apr 2026',
      day: '10',
      month: 'Apr',
      year: '2026',
      title: 'Annual Day Celebration',
      subTitle: 'annual-day-2026',
    },
    {
      imgUrl: 'https://placehold.co/600x400/EEE/31343C',
      date: '15 May 2026',
      day: '15',
      month: 'May',
      year: '2026',
      title: 'Summer Camp 2026',
      subTitle: 'summer-camp-2026',
    },
    {
      imgUrl: 'https://placehold.co/600x400/EEE/31343C',
      date: '20 Jun 2026',
      day: '20',
      month: 'Jun',
      year: '2026',
      title: 'Science Exhibition',
      subTitle: 'science-exhibition',
    }
  ];

  staticCircular: any[] = [
    {
      $key: '1',
      date: '21 Jan 2026',
      title: 'Board datesheet class XII',
      desc: 'Important dates for Class XII board examinations.',
      urlPath: '/assets/pdf/circulars/Board datesheet class XII.pdf',
    },
    {
      $key: '2',
      date: '03 Dec 2025',
      title: 'Board datesheet Class X',
      desc: 'Important dates for Class X board examinations.',
      urlPath: '/assets/pdf/circulars/Board datesheet class X.pdf',
    }
  ];

  staticNews: any[] = [
    {
      $key: '1',
      date: '01/02/2025',
      title: 'Admission Open',
      desc: 'Admissions are now open for the academic year 2025-26.',
      urlPath: ''
    }
  ];

  staticPress: any[] = [
    {
      $key: '1',
      date: '15 Mar 2026',
      title: 'Aryakulam Shines in Regional Sports',
      desc: 'Our students secured top positions in the inter-school athletic meet held last week.',
      urlPath: ''
    },
    {
      $key: '2',
      date: '10 Feb 2026',
      title: 'Innovative Science Fair 2026',
      desc: 'Local media covered our annual science exhibition featuring solar-powered robot prototypes.',
      urlPath: ''
    }
  ];

  circular: any[] = [];
  news: any[] = [];
  press: any[] = [];

  constructor(
    private firebase: AngularFireDatabase,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // 1. Initial fallback data
    this.circular = [...this.staticCircular];
    this.news = [...this.staticNews];
    this.press = [...this.staticPress];

    // 2. Realtime listener to Firebase key 'press'
    this.subPress = this.firebase.object('press').valueChanges().subscribe({
      next: (res: any) => {
        if (res) {
          this.parsePressData(res);
        } else {
          this.fetchPressViaRest();
        }
      },
      error: () => {
        this.fetchPressViaRest();
      }
    });

    // 3. Realtime listener to Firebase key 'notices'
    this.subNotices = this.firebase.object('notices').valueChanges().subscribe({
      next: (res: any) => {
        if (res) {
          this.parseNoticesData(res);
        } else {
          this.fetchNoticesViaRest();
        }
      },
      error: () => {
        this.fetchNoticesViaRest();
      }
    });

    // 4. Fast REST fallbacks
    this.fetchPressViaRest();
    this.fetchNoticesViaRest();
  }

  private parsePressData(data: any) {
    if (!data) {
      this.press = [...this.staticPress];
      this.cdr.detectChanges();
      return;
    }

    let rawList: any[] = [];
    if (Array.isArray(data)) {
      rawList = data.filter(i => i !== null && i !== undefined);
    } else if (typeof data === 'object') {
      rawList = Object.keys(data).map(k => ({ ...data[k], $key: k })).filter(i => i !== null && i !== undefined);
    }

    const dynamicPress = rawList.map((item, idx) => {
      const title = item.title || item.caption || item.name || 'Press Release ' + (idx + 1);
      const desc = item.desc || item.description || title;
      const date = item.date || item.year || new Date().toLocaleDateString();
      const urlPath = item.imgUrl || item.imageUrl || item.fileUrl || item.url || item.link || '';

      return {
        $key: item.$key || String(idx),
        date: String(date),
        title: String(title),
        desc: String(desc),
        urlPath: String(urlPath)
      };
    });

    if (dynamicPress.length > 0) {
      this.press = [...dynamicPress, ...this.staticPress];
    } else {
      this.press = [...this.staticPress];
    }

    this.cdr.detectChanges();
  }

  private parseNoticesData(data: any) {
    if (!data) {
      this.circular = [...this.staticCircular];
      this.news = [...this.staticNews];
      this.cdr.detectChanges();
      return;
    }

    let rawList: any[] = [];
    if (Array.isArray(data)) {
      rawList = data.filter(i => i !== null && i !== undefined);
    } else if (typeof data === 'object') {
      rawList = Object.keys(data).map(k => ({ ...data[k], $key: k })).filter(i => i !== null && i !== undefined);
    }

    const dynamicNotices = rawList.map((item, idx) => {
      const title = item.title || item.name || item.caption || 'Notice ' + (idx + 1);
      const desc = item.desc || item.description || title;
      const date = item.date || item.year || new Date().toLocaleDateString();
      const urlPath = item.fileUrl || item.imgUrl || item.imageUrl || item.url || item.link || item.pdfUrl || '';

      return {
        $key: item.$key || String(idx),
        date: String(date),
        title: String(title),
        desc: String(desc),
        urlPath: String(urlPath)
      };
    });

    if (dynamicNotices.length > 0) {
      this.circular = [...dynamicNotices, ...this.staticCircular];
      this.news = [...dynamicNotices, ...this.staticNews];
    } else {
      this.circular = [...this.staticCircular];
      this.news = [...this.staticNews];
    }

    this.cdr.detectChanges();
  }

  private async fetchPressViaRest() {
    try {
      const config = (environment as any).firebaseConfig || (environment as any).firebase;
      if (!config || !config.databaseURL) return;
      const res = await fetch(`${config.databaseURL}/press.json`);
      if (res.ok) {
        const json = await res.json();
        if (json) this.parsePressData(json);
      }
    } catch (e) {
      console.warn('Press REST fetch notice:', e);
    }
  }

  private async fetchNoticesViaRest() {
    try {
      const config = (environment as any).firebaseConfig || (environment as any).firebase;
      if (!config || !config.databaseURL) return;
      const res = await fetch(`${config.databaseURL}/notices.json`);
      if (res.ok) {
        const json = await res.json();
        if (json) this.parseNoticesData(json);
      }
    } catch (e) {
      console.warn('Notices REST fetch notice:', e);
    }
  }

  openItem(item: any) {
    if (item && item.urlPath && item.urlPath.trim() !== '') {
      window.open(item.urlPath, '_blank');
    }
  }

  ngOnDestroy(): void {
    if (this.subPress) this.subPress.unsubscribe();
    if (this.subNotices) this.subNotices.unsubscribe();
  }
}
